import { render, staticRenderFns } from "./MenuSelect.vue?vue&type=template&id=4c5b16d4&scoped=true&"
import script from "./MenuSelect.vue?vue&type=script&lang=ts&"
export * from "./MenuSelect.vue?vue&type=script&lang=ts&"
import style0 from "./MenuSelect.vue?vue&type=style&index=0&id=4c5b16d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b16d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListItem,VListItemTitle,VMenu})
